





















import './GuestGuide.scss'
import { defineComponent } from '@vue/composition-api'
import { KisweIcon } from '@/modules/kisweui/components'
import useTranslations from '@/compositions/translations'

export default defineComponent({
  name: 'GuestGuide',
  components: {
    KisweIcon
  },
  setup () {
    return {
      ...useTranslations()
    }
  }
})
